import i18next from '../../i18n.ts';
import { normalizeIdentifier, isEmail, isUsername } from '../auth/identifier';

export const emailFormValidator = (value: string): string | null => {
  return /^\S+@\S+$/.test(value) ? null : i18next.t('FormValidator:email');
};
export const userNameValidator = (value: string): string | null => {
  return /^(?=.{3,30}$)[a-z0-9][a-z0-9._-]*$/.test(value)
    ? null
    : i18next.t('FormValidator:username');
};

export const identifierFormValidator = (value: string, t: (key: string) => string): string | null => {
  const requiredValidatorRes = requiredFieldFormValidator(value);
  if (requiredValidatorRes) return requiredValidatorRes;

  const normalized = normalizeIdentifier(value);
  if (isEmail(normalized) || isUsername(normalized)) {
    return null;
  }

  return t('FormValidator:invalidIdentifier');
};
export const requiredFieldFormValidator = (value: any): string | null => {
  return value === undefined || value === null || value === ''
    ? i18next.t('FormValidator:required')
    : null;
};

export const validatePasswordEqualString = (value1: string, value2: string): string | null => {
  return value1 !== value2 ? i18next.t('FormValidator:mustBeEqualPassword') : null;
};

export const validateGreaterThan = (value: number, greatherThanValue: number): string | null => {
  return value <= greatherThanValue ? `Valor debe ser mayor que ${greatherThanValue}` : null;
};

export const validateSettingTaxField = (value1: string, value2: string): string | null => {
  const isMissing = (value: string | number | null | undefined) =>
    value === undefined || value === null || value === '';
  const oneIsMissing = isMissing(value1) || isMissing(value2);
  const bothAreEmpty = isMissing(value1) && isMissing(value2);
  return oneIsMissing && !bothAreEmpty
    ? 'Nombre y Valor de Impuesto son requeridos o ambos deben ser eliminados'
    : null;
};

export const validateLength = (
  minLength: number,
  maxLength: number,
  value: number
): string | null => {
  if (minLength > value) {
    return `Valor debe tener minimo ${minLength} caracteres`;
  }

  if (maxLength < value) {
    return `Valor debe tener maximo ${maxLength} caracteres`;
  }

  return null;
};
